import React from 'react';
import CookiesPopup from "../Components/CookiesPopup"


const DevTestingPage = () => {
    return (
        <div>
            <span>This is a temp page for testing stuff, remove it soon</span>
            <CookiesPopup />
        </div>
    );
};

export default DevTestingPage;